<template>
  <div class="new-reports d-flex flex-column">
    <div
      class="
        new-reports-header
        py-2
        px-3
        d-flex
        align-items-center
        justify-content-between
      "
    >
      <div class="title-nav d-flex align-items-center">
        <span class="title">Reports</span>
      </div>
    </div>
    <div class="reports-flex">
      <div
        class="report-brief pt-4 pb-1 px-4"
        v-if="roles.includes('GET_REPORT_CUSTOMER')"
      >
        <div class="report-title d-flex align-items-center">
          <img
            src="../../assets/ReportsNew/cust_reports_icon.svg"
            alt="Customer Reports"
            class="icon"
          />
          <span class="report-name">Customer Reports</span>
        </div>
        <div class="report-desc">View detailed insights and analytics</div>
        <div class="report-cta py-2" @click="goToCustomer">
          <button type="button">View</button>
        </div>
      </div>
      <div
        class="report-brief pt-4 pb-1 px-4"
        v-if="roles.includes('GET_REPORT_RECRUITER')"
      >
        <div class="report-title d-flex align-items-center">
          <img
            src="../../assets/ReportsNew/recr_reports_icon.svg"
            alt="Customer Reports"
            class="icon"
          />
          <span class="report-name">Recruiter Reports</span>
        </div>
        <div class="report-desc">View detailed insights and analytics</div>
        <div class="report-cta py-2" @click="goToRecruiter">
          <button type="button">View</button>
        </div>
      </div>
      <div
        class="report-brief pt-4 pb-1 px-4"
        v-if="roles.includes('GET_REPORT_PANELIST')"
      >
        <div class="report-title d-flex align-items-center">
          <img
            src="../../assets/ReportsNew/pan_reports_icon.svg"
            alt="Customer Reports"
            class="icon"
          />
          <span class="report-name">Panelist Reports</span>
        </div>
        <div class="report-desc">View detailed insights and analytics</div>
        <div class="report-cta py-2" @click="goToPanelist">
          <button type="button">View</button>
        </div>
      </div>
      <div
        class="report-brief pt-4 pb-1 px-4"
        v-if="roles.includes('GET_REPORT_VENDOR')"
      >
        <div class="report-title d-flex align-items-center">
          <img
            src="../../assets/ReportsNew/vendor_reports_icon.svg"
            alt="Customer Reports"
            class="icon"
          />
          <span class="report-name">Vendor Reports</span>
        </div>
        <div class="report-desc">View detailed insights and analytics</div>
        <div class="report-cta py-2" @click="goToVendor">
          <button type="button">View</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "Reports",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  methods: {
    goToCustomer() {
      this.$router.push({
        name: "CustomerReport",
      });
    },
    goToRecruiter() {
      this.$router.push({
        name: "RecruiterReport",
      });
    },
    goToPanelist() {
      this.$router.push({
        name: "PanelistReport",
      });
    },
    goToVendor() {
      this.$router.push({
        name: "VendorReport",
      });
    },
  },
};
</script>
<style scoped>
.new-reports {
  position: relative;
  padding: 15px 20px 0px 77px;
  top: 71px;
  height: calc(100vh - 71px);
  background-color: #e9ecef;
  overflow-y: scroll;
  font-family: "Lato", sans-serif;
}

.new-reports .new-reports-header {
  background-color: #f6f9fb;
  border-radius: 6px;
}

.new-reports .new-reports-header .title-nav {
  gap: 18px;
}

.new-reports .new-reports-header .title-nav .title {
  color: #20639b;
  font-weight: 600;
  font-size: 20px;
}

.new-reports .reports-flex {
  padding: 40px;
  background-color: #fff;
  border-radius: 6px;
  margin-top: 12px;
  height: calc(100vh - 160px);
  display: flex;
  align-items: flex-start;
  gap: 24px;
  flex-wrap: wrap;
  overflow-y: auto;
  overflow-x: hidden;
}

.new-reports .reports-flex .report-brief {
  box-shadow: 0 0 15px #10101032;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 280px;
  gap: 12px;
}

.new-reports .reports-flex .report-brief .report-title {
  justify-content: space-evenly;
  width: 100%;
  font-weight: 600;
}

.new-reports .reports-flex .report-brief .report-desc {
  text-align: center;
  color: #7a7a7a;
}

.new-reports .reports-flex .report-brief .report-cta {
  border-top: 1px solid #888888;
  width: 100%;
  text-align: center;
}

.new-reports .reports-flex .report-brief .report-cta button {
  background-color: transparent;
  border: none;
  width: 100%;
  padding: 10px;
  color: #20639b;
  font-weight: 600;
}

.new-reports .reports-flex .report-brief .report-cta button:hover {
  background-color: #eef3f7;
  border-radius: 6px;
}

@media screen and (max-width: 1024px) {
  .new-reports {
    padding: 15px 20px 0px 20px;
  }
}
</style>
